import React, { useState } from 'react';
import SecureMarkdownRenderer from './SecureMarkdownRenderer';
import { getPlatformEmoji, getStatusEmoji, getImageUrl } from '../utils/helpers';

function UserAvatar({ session, stepId, planId, onViewSession }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const stepResult = session.steps.find(s => s.step_id === stepId);
  const result = stepResult?.result || 'untested';
  
  const getInitials = (name) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  // Using helper function from utils/helpers.js

  const getPlatformClass = (platform) => {
    switch (platform.toLowerCase()) {
      case 'ios': return 'ios';
      case 'android': return 'android';
      case 'web': return 'web';
      default: return 'other';
    }
  };

  // Using helper function from utils/helpers.js

  const handleMouseEnter = (e) => {
    const rect = e.target.getBoundingClientRect();
    setTooltipPosition({
      x: rect.left + rect.width / 2,
      y: rect.top - 10
    });
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const handleClick = () => {
    onViewSession(session);
  };

  return (
    <>
      <div
        className={`user-avatar ${result.toLowerCase()}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
        title={`${session.username} on ${session.platform} - ${result}`}
      >
        {getInitials(session.username)}
        
        <div className={`platform-badge ${getPlatformClass(session.platform)}`}>
          {getPlatformEmoji(session.platform)}
        </div>
        
        <div className={`status-badge ${result.toLowerCase()}`}>
          {getStatusEmoji(result)}
        </div>
      </div>

      {showTooltip && stepResult && (
        <div 
          className="user-tooltip"
          style={{
            position: 'fixed',
            left: tooltipPosition.x - 125,
            top: tooltipPosition.y - 10,
            transform: 'translateY(-100%)'
          }}
        >
          <h4>{session.username} on {session.platform}</h4>
          <p><strong>Result:</strong> {stepResult.result}</p>
          {stepResult.notes && (
            <div>
              <strong>Notes:</strong>
              <SecureMarkdownRenderer>{stepResult.notes}</SecureMarkdownRenderer>
            </div>
          )}
          {stepResult.images && stepResult.images.length > 0 && (
            <div>
              <p><strong>Images:</strong></p>
              <div className="images">
                {stepResult.images.map((image, index) => (
                  <img key={index} src={getImageUrl(image, planId)} alt={`Screenshot ${index + 1}`} />
                ))}
              </div>
            </div>
          )}
          <p style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.5rem' }}>
            Click to view full session
          </p>
        </div>
      )}
    </>
  );
}

export default UserAvatar; 